// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RzIw","right":"styles_right__3eR9R"};